export const whiteLocaleList = ['jp', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'ph']; //白名单
export const productPageUrl = 'rapid-power-bank';
export const productPageTheme = 'white'; //主题色
export const tabsValues = ['Product', 'Bundles'];
export const generalKey = ['rapid_016_cable', 'rapid_016', 'rapid-3-in-1-35W'];
export const GeneralKeys = ['rapid_016_cable', 'rapid_016', 'rapid-3-in-1-35W'];
export const generalKey_US = ['rapid_016_cable', 'rapid_016'];
export const GeneralKeys_US = ['rapid_016_cable', 'rapid_016'];
export const generalKey_PH = ['rapid_016'];
export const GeneralKeys_PH = ['rapid_016'];
